<template>
  <div class="col-md-12 flex flex-column mt-4 claim-data" :class="$_can('claims.update') ? 'active' : ''" @mouseover="active = true" @mouseleave="active = false">
    <div class="row">
      <div class="col-md-10 claim-data-title" v-if="!editData">{{ claimById.title }}</div>
      <div class="col-md-10 claim-data-title" v-if="editData">
        <input
          v-model="claim.title"
          type="text"
          class="edit-input w-full"
        />
      </div>
      <div class="col-md-2 flex justify-content-end" v-if="active && $_can('claims.update')" @click="toggleEdit"><span class="fa fa-pencil pointer edit-icon" /></div>
    </div>
    <span class="assignee-title">Claim description</span>
    <span class="claim-data-description description-format" v-if="!editData">
      {{ claimById.description }}
    </span>
    <span class="claim-data-description" v-if="editData">
      <textarea
        v-model="claim.description"
        type="text"
        class="edit-input w-full mt-1"
        v-auto-resize
      />
      <span class="mt-1">
        <button class="btn btn-primary"
                v-if="editData"
                @click="claimUpdate"
                :disabled="buttonDisabled"
        >
          Save
        </button>
        <button class="btn btn-secondary" v-if="editData" @click="toggleEdit">Cancel</button>
      </span>
    </span>
  </div>
</template>
<script>
import toastr from 'toastr';
import axios from 'axios';

export default {
  name: 'ClaimDescription',
  props: {
    claimById: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      claim: {
        title: '',
        description: '',
      },
      editData: false,
      active: false,
      buttonDisabled: false,
    };
  },
  created() {
    this.claim = this.claimById;
  },
  methods: {
    toggleEdit() {
      this.editData = !this.editData;
      this.buttonDisabled = false;
    },
    claimUpdate() {
      this.buttonDisabled = true;
      axios
        .put(`/claims/${this.$route.params.id}`, {
          title: this.claim.title,
          description: this.claim.description,
        })
        .then(() => {
          toastr.success('Claim updated successfully');
          this.toggleEdit();
          this.$emit('update');
        })
        .catch(err => {
          toastr.error(err);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
  },
};
</script>

<style scoped>
.claim-data {
  background-color: #ffffff;
  box-shadow: 0 1px 3px 0 rgba(43, 59, 93, 0.15);
  padding: 16px;
}

.claim-data .row {
  margin: 0;
}

.active:hover {
  background: #f4f5f7;
}

.claim-data-title {
  color: #212529;
  font-family: Roboto;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  padding-bottom: 16px;
  padding-left: 0;
  word-wrap: break-word;
}

.claim-data-description {
  color: #4c5669;
  font-size: 14px;
  line-height: 20px;
  word-wrap: break-word;
}

.assignee-title {
  opacity: 0.7;
  color: #808d98;
  font-size: 11px;
  font-weight: 500;
  line-height: 12px;
}

.edit-input {
  font-size: 14px;
}

.edit-icon {
  color: #2962ff;
}

.description-format {
  white-space: pre-line;
}
</style>



// WEBPACK FOOTER //
// src/components/claims/ClaimDescription.vue